webpackJsonp([1],{

/***/ "+r2N":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"home"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-content-wrapper"},[_c('h1',[_vm._v("Welcome to Jwayelani")]),_vm._v(" "),_c('p',[_vm._v("Jwayelani is a local supermarket chain and trusted supplier to the various communities we serve. Jwayelani was acquired by Kind Investments in April 2019. We are still trading as your beloved Jwayelani, with skilful staff, top-quality products, and several stores nationwide to help you save more whilst creating an enjoyable shopping experience with every visit.")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__("gkTP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("X/gF");
function injectStyle (ssrContext) {
  __webpack_require__("qoDK")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "05zT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__ = __webpack_require__("e9Us");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217c11e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__ = __webpack_require__("OA1P");
function injectStyle (ssrContext) {
  __webpack_require__("HqTv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-217c11e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ContactUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_217c11e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0R+G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0sSV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1/qb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('sticky', {
  bind: function bind(el) {

    var stuckThreshold = 0;
    var stuck = false;

    window.addEventListener('scroll', function () {
      var coords = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$utils.getCoords(el);
      if (!stuck) {
        stuckThreshold = coords.top;
      }

      if (coords.scrollTop >= stuckThreshold && !stuck) {
        el.classList.add('stuck');
        stuck = true;
      } else if (coords.scrollTop < stuckThreshold && stuck) {
        el.classList.remove('stuck');
        stuck = false;
      }
    });
  }
});

/***/ }),

/***/ "1xb8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-store-locator_xs.7ec357f.jpg";

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4ajz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _photos = {
  xs: __webpack_require__("arl9"),
  s: __webpack_require__("b2as"),
  m: __webpack_require__("Ekns"),
  l: __webpack_require__("XjXy")
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'about-us',
  data: function data() {
    return {};
  },

  computed: {
    photos: function photos() {
      return _photos;
    }
  }
});

/***/ }),

/***/ "5ANv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({ref:"input"},'input',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("GY//");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("zfG0");
function injectStyle (ssrContext) {
  __webpack_require__("vGh4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__("El0Z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("NuQ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8Mkj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9M+g":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AxXu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-store-locator_m.a772bcf.jpg";

/***/ }),

/***/ "CYef":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"logo",on:{"click":function($event){return _vm.scrollTo('main-nav')}}},[_c('img',{attrs:{"src":__webpack_require__("ZPKi"),"alt":""}})]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('j-footer',{staticClass:"footer"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('section',{staticStyle:{"display":"flex","align-items":"center","justify-content":"center"},attrs:{"id":"contact-us"}},[_c('h1',{staticStyle:{"text-align":"center","font-size":"24px"}},[_vm._v("There is no current news to display.")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4uH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__ = __webpack_require__("dXrS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__ = __webpack_require__("O0jz");
function injectStyle (ssrContext) {
  __webpack_require__("c0Rt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Icon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e22f0aa_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Icon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EZvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__ = __webpack_require__("mvlf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3081e48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__ = __webpack_require__("CYef");
function injectStyle (ssrContext) {
  __webpack_require__("UYIS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3081e48a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_News_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3081e48a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_News_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "EjQ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__ = __webpack_require__("t/Fq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78297306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__ = __webpack_require__("iyad");
function injectStyle (ssrContext) {
  __webpack_require__("8Mkj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-78297306"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78297306_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MainNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ekns":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-about_m.8b69cb7.jpg";

/***/ }),

/***/ "El0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));

/***/ }),

/***/ "F4hn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fs8J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_MainNav__ = __webpack_require__("EjQ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Landing__ = __webpack_require__("X4if");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AboutUs__ = __webpack_require__("kHun");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Promotions__ = __webpack_require__("eWwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Gallery__ = __webpack_require__("sl25");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_StoreLocator__ = __webpack_require__("M3tB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_ContactUs__ = __webpack_require__("05zT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Footer__ = __webpack_require__("TVmP");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





//import PromotionBanner from '@/components/PromotionBanner'

// import Supermarket from '@/components/Supermarket'
// import Butchery from '@/components/Butchery'
// import MeatPlant from '@/components/MeatPlant'
// import DistributionCentre from '@/components/DistributionCentre'




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  components: { MainNav: __WEBPACK_IMPORTED_MODULE_0__components_MainNav__["a" /* default */], Landing: __WEBPACK_IMPORTED_MODULE_1__components_Landing__["a" /* default */], AboutUs: __WEBPACK_IMPORTED_MODULE_2__components_AboutUs__["a" /* default */], Gallery: __WEBPACK_IMPORTED_MODULE_4__components_Gallery__["a" /* default */], Promotions: __WEBPACK_IMPORTED_MODULE_3__components_Promotions__["a" /* default */], /* PromotionBanner, Supermarket, Butchery, MeatPlant, DistributionCentre, */StoreLocator: __WEBPACK_IMPORTED_MODULE_5__components_StoreLocator__["a" /* default */], ContactUs: __WEBPACK_IMPORTED_MODULE_6__components_ContactUs__["a" /* default */], JFooter: __WEBPACK_IMPORTED_MODULE_7__components_Footer__["a" /* default */] },
  created: function created() {
    window.gtag('event', 'page', {
      'page': '/',
      'title': 'Home'
    });
  },
  data: function data() {
    return {};
  }
});

/***/ }),

/***/ "GY//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));

/***/ }),

/***/ "GYib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "HKjq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promotions',
  created: function created() {},
  data: function data() {
    return {
      currentImage: null,
      imagesPath: './static/gallery/',
      images: [{ name: 'IMG-20250307-WA0016.jpg', portrait: false }, { name: 'IMG-20250307-WA0017.jpg', portrait: false }, { name: 'IMG-20250307-WA0019.jpg', portrait: false }, { name: 'IMG-20250307-WA0021.jpg', portrait: false }, { name: 'IMG-20250307-WA0022.jpg', portrait: false }, { name: 'IMG-20250307-WA0024.jpg', portrait: false }, { name: 'IMG-20250307-WA0025.jpg', portrait: false }, { name: 'IMG-20250307-WA0026.jpg', portrait: false }, { name: '20240220_114959.jpg', portrait: false }, { name: '20240220_115002.jpg', portrait: false }, { name: '20240220_115004.jpg', portrait: false }, { name: '20240220_115008.jpg', portrait: false }, { name: '20240220_115032.jpg', portrait: false }, { name: '20240220_115040.jpg', portrait: false }, { name: '20240220_115114.jpg', portrait: false }, { name: '20240220_115147.jpg', portrait: false }, { name: '20240220_115304.jpg', portrait: false }, { name: '20240220_112812.jpg', portrait: false }, { name: '20210127_123739.jpg', portrait: false }, { name: '20210128_123341.png', portrait: false }, { name: '20220209_103307.jpg', portrait: false }, { name: '20220209_105344.jpg', portrait: false }, { name: '20220209_105455.jpg', portrait: false }, { name: '20220209_105529.jpg', portrait: false }, { name: '20220209_105733.jpg', portrait: false }, { name: '20220301_111542.jpg', portrait: false }, { name: '20220301_111555.jpg', portrait: false }, { name: '20220301_111615.jpg', portrait: false }, { name: '20220301_111720.jpg', portrait: false }, { name: '20220301_111727.jpg', portrait: false }, { name: '20220301_111753.jpg', portrait: false }, { name: '20220301_111827.jpg', portrait: false }, { name: 'IMG-20220209-WA0006.jpg', portrait: false }]
    };
  },

  methods: {
    showFullImage: function showFullImage(imageUrl) {
      this.$data.currentImage = imageUrl;
    }
  },
  computed: {},
  directives: {
    gallery: {
      // directive definition
      inserted: function inserted(el) {}
    }
  }
});

/***/ }),

/***/ "HqTv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M3tB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLocator_vue__ = __webpack_require__("zF5S");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca168ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLocator_vue__ = __webpack_require__("YZ92");
function injectStyle (ssrContext) {
  __webpack_require__("tngd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ca168ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StoreLocator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ca168ba_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StoreLocator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3846dc98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("u5Yc");
function injectStyle (ssrContext) {
  __webpack_require__("yUv6")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3846dc98_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__ = __webpack_require__("sA6N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__("Tqaz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_resource__ = __webpack_require__("8+8L");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_touch_events__ = __webpack_require__("ufW0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_touch_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_touch_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_Utils__ = __webpack_require__("r0IB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__plugins_Easing__ = __webpack_require__("O7OU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_ScrollTo__ = __webpack_require__("oJPq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_sticky__ = __webpack_require__("1/qb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directives_lazy_load__ = __webpack_require__("pLgy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vee_validate__ = __webpack_require__("sUu7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_moment__ = __webpack_require__("8AgW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__("9M+g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_awesome_icons_search__ = __webpack_require__("T4wd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_awesome_icons_times__ = __webpack_require__("1UlI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vue_awesome_icons_phone__ = __webpack_require__("73Iz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_awesome_icons_map_marker__ = __webpack_require__("LH9c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_awesome_icons_paper_plane_o__ = __webpack_require__("DPA4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_awesome_icons_facebook_f__ = __webpack_require__("xfIr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_awesome_icons_shopping_basket__ = __webpack_require__("dNSv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue_awesome_icons_industry__ = __webpack_require__("3jHl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_awesome_icons_cubes__ = __webpack_require__("7Pwk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_vue_awesome_icons_video_camera__ = __webpack_require__("as/q");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_vue_awesome_icons_chevron_up__ = __webpack_require__("CxVc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_awesome_icons_chevron_right__ = __webpack_require__("kb/u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_vue_awesome_icons_chevron_left__ = __webpack_require__("jlxx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_awesome_icons_ellipsis_h__ = __webpack_require__("bWbu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_awesome_icons_check__ = __webpack_require__("D/Bo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_awesome_components_Icon__ = __webpack_require__("D4uH");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.














// import VueAnalytics from 'vue-analytics'





















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('icon', __WEBPACK_IMPORTED_MODULE_31_vue_awesome_components_Icon__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7__plugins_Utils__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_8__plugins_Easing__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9__plugins_ScrollTo__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_touch_events___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue2_google_maps__, {
  load: {
    key: 'AIzaSyB8klBrTutZkfzpNWPivz4DxwUVbfqjeDs',
    libraries: 'places'
  }
});
/*Vue.use(VueAnalytics, {
  id: 'UA-106536080-1',
  autoTracking: {
    page: false
  }
})*/

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */] }
});

/***/ }),

/***/ "Ngrk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('main-nav'),_vm._v(" "),_c('landing',{staticClass:"landing"}),_vm._v(" "),_c('about-us',{staticClass:"landing"}),_vm._v(" "),_c('gallery',{staticClass:"gallery"}),_vm._v(" "),_c('promotions',{staticClass:"promotions"}),_vm._v(" "),_c('store-locator',{staticClass:"store-locator"}),_vm._v(" "),_c('contact-us',{staticClass:"contact-us"}),_vm._v(" "),_c('j-footer',{staticClass:"footer"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NuQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NzJi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gallery"},[_c('div',{staticClass:"container",attrs:{"id":"gallery"}},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"gallery-images"},[_vm._l((_vm.images),function(image){return _c('li',{staticClass:"gallery-image"},[_c('div',{staticClass:"image-wrapper",on:{"click":function($event){return _vm.showFullImage(image)}}},[_c('img',{directives:[{name:"lazy-load",rawName:"v-lazy-load:src",value:(_vm.imagesPath + image.name + ''),expression:"imagesPath + image.name + ''",arg:"src"}],class:{'portrait': image.portrait},attrs:{"alt":""}})])])}),_vm._v(" "),_c('li',{staticClass:"clearfix"})],2),_vm._v(" "),_c('div',{staticClass:"image-zoom",class:{'active': _vm.currentImage != null},on:{"click":function($event){_vm.currentImage = null}}},[(_vm.currentImage)?_c('img',{class:{'portrait': _vm.currentImage.portrait},attrs:{"src":_vm.imagesPath + _vm.currentImage.name + '',"alt":""}}):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-content-wrapper"},[_c('h2',[_vm._v("Gallery")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O0jz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.klass,style:(_vm.style),attrs:{"version":"1.1","role":_vm.label ? 'img' : 'presentation',"aria-label":_vm.label,"x":_vm.x,"y":_vm.y,"width":_vm.width,"height":_vm.height,"viewBox":_vm.box}},[_vm._t("default",[(_vm.icon && _vm.icon.paths)?_vm._l((_vm.icon.paths),function(path,i){return _c('path',_vm._b({key:("path-" + i)},'path',path,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.polygons)?_vm._l((_vm.icon.polygons),function(polygon,i){return _c('polygon',_vm._b({key:("polygon-" + i)},'polygon',polygon,false))}):_vm._e(),_vm._v(" "),(_vm.icon && _vm.icon.raw)?[_c('g',{domProps:{"innerHTML":_vm._s(_vm.raw)}})]:_vm._e()])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O7OU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Easing = {};

Easing.install = function (Vue) {
  var service = {
    // no easing, no acceleration
    linear: function linear(t) {
      return t;
    },
    // accelerating from zero velocity
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    // decelerating to zero velocity
    easeOutQuad: function easeOutQuad(t) {
      return t * (2 - t);
    },
    // acceleration until halfway, then deceleration
    easeInOutQuad: function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    // accelerating from zero velocity
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    // decelerating to zero velocity
    easeOutCubic: function easeOutCubic(t) {
      return --t * t * t + 1;
    },
    // acceleration until halfway, then deceleration
    easeInOutCubic: function easeInOutCubic(t) {
      return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    },
    // accelerating from zero velocity
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    // decelerating to zero velocity
    easeOutQuart: function easeOutQuart(t) {
      return 1 - --t * t * t * t;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuart: function easeInOutQuart(t) {
      return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
    },
    // accelerating from zero velocity
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    // decelerating to zero velocity
    easeOutQuint: function easeOutQuint(t) {
      return 1 + --t * t * t * t * t;
    },
    // acceleration until halfway, then deceleration
    easeInOutQuint: function easeInOutQuint(t) {
      return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
    }
  };

  Vue.$easing = service;
};

/* harmony default export */ __webpack_exports__["a"] = (Easing);

/***/ }),

/***/ "OA1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"contact-us"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-content-wrapper"},[_c('h1',[_vm._v("Contact Us")]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12 col-lg-4 contact-form"},[_c('div',{staticClass:"block"},[_c('h4',[_vm._v("Leave a Message")]),_vm._v(" "),_c('form',{attrs:{"name":"contactForm"},on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"form-group"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('name')),expression:"errors.has('name')"}],staticClass:"invalid"},[_vm._v("\n                  "+_vm._s(_vm.errors.first('name'))+"\n                ")]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.name),expression:"form.name"}],staticClass:"form-control",attrs:{"type":"name","id":"name","name":"name","placeholder":"Enter Your Name","required":""},domProps:{"value":(_vm.form.name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "name", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('email')),expression:"errors.has('email')"}],staticClass:"invalid"},[_vm._v("\n                  "+_vm._s(_vm.errors.first('email'))+"\n                ")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.email),expression:"form.email"}],staticClass:"form-control",attrs:{"type":"email","id":"email","name":"email","placeholder":"Enter Your Email","required":""},domProps:{"value":(_vm.form.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "email", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.errors.has('message')),expression:"errors.has('message')"}],staticClass:"invalid"},[_vm._v("\n                  "+_vm._s(_vm.errors.first('message'))+"\n                ")]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.message),expression:"form.message"}],staticClass:"form-control",attrs:{"name":"message","rows":"3","required":""},domProps:{"value":(_vm.form.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "message", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"recaptcha-section"},[_c('div',{staticClass:"recaptcha-wrapper"},[_c('vue-recaptcha',{ref:"recaptcha",staticClass:"recaptcha",attrs:{"sitekey":_vm.recaptchaSiteKey},on:{"verify":_vm.onVerify,"expired":_vm.onExpired}})],1),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('button',{staticClass:"submit-button btn btn-lg",attrs:{"type":"submit","disabled":_vm.form.isSending || _vm.form.isSent,"name":"button"}},[(!_vm.form.isSending && !_vm.form.isSent)?_c('span',[_vm._v("Send "),_c('icon',{staticClass:"paper-plane-o-icon",attrs:{"name":"paper-plane-o"}})],1):_vm._e(),_vm._v(" "),(_vm.form.isSent)?_c('span',[_vm._v("Success "),_c('icon',{staticClass:"check-icon",attrs:{"name":"check"}})],1):_vm._e(),_vm._v(" "),(_vm.form.isSending)?_c('span',[_vm._v("Sending "),_c('icon',{staticClass:"ellipsis-h-icon",attrs:{"name":"ellipsis-h"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-lg-4"},[_c('div',{staticClass:"block"},[_c('h4',[_vm._v("Physical Address")]),_vm._v(" "),_c('p',[_vm._v("\n              Head Office"),_c('br'),_vm._v("\n              19 Tottum Road,"),_c('br'),_vm._v("\n              Cornubia Industrial Estate,"),_c('br'),_vm._v("\n              Cornubia\n            ")])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('h4',[_vm._v("Postal Address")]),_vm._v(" "),_c('p',[_vm._v("\n              PO Box 4675"),_c('br'),_vm._v("\n              Durban"),_c('br'),_vm._v("\n              4000\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6 col-lg-4 contact-details"},[_c('div',{staticClass:"block"},[_c('h4',[_vm._v("Telephone")]),_vm._v(" "),_c('p',[_vm._v("\n              031 303 3864"),_c('br'),_vm._v("\n              086 527 6659 (Fax)\n            ")])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('h4',[_vm._v("Email")]),_vm._v(" "),_c('p',[_c('b',[_vm._v("General")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:info@jwayelani.co.za"}},[_vm._v("info@jwayelani.co.za")]),_c('br'),_vm._v(" "),_c('b',[_vm._v("CV Submission")]),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"mailto:recruitment@jwayelani.co.za"}},[_vm._v("recruitment@jwayelani.co.za")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"name"}},[_vm._v("Name "),_c('i',{staticClass:"glyphicon glyphicon-asterisk"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"email"}},[_vm._v("Email Address "),_c('i',{staticClass:"glyphicon glyphicon-asterisk"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"email"}},[_vm._v("Message "),_c('i',{staticClass:"glyphicon glyphicon-asterisk"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recaptcha-privacy-and-terms"},[_vm._v("\n                    reCaptcha\n                    "),_c('a',{attrs:{"href":"https://www.google.com/intl/en/policies/privacy/","target":"_blank"}},[_vm._v("Privacy")]),_vm._v(" /\n                    "),_c('a',{attrs:{"href":"https://www.google.com/intl/en/policies/terms/","target":"_blank"}},[_vm._v("Terms")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PJX0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'landing',
  created: function created() {
    /*this.$http.get('http://jwayelani.13th.co.za:3000/latest_facebook_posts').then(function (response) {
      console.log(response)
        this.$data.facebookPosts = response.body
    }, function (error) {
      console.log(error)
    })*/
  },
  data: function data() {
    return {
      facebookPosts: []
    };
  }
});

/***/ }),

/***/ "Qso1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"banner half-vh"},[_c('img',{staticClass:"banner-image",attrs:{"src":__webpack_require__("XjXy"),"alt":"","srcset":_vm.photos.xs + ' 320w, ' + _vm.photos.s + ' 768w, ' + _vm.photos.m + ' 1440w, ' + _vm.photos.l + ' 1920w'}})]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"about-us"}},[_c('div',{staticClass:"text-content-wrapper"},[_c('h1',[_vm._v("About Jwayelani")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-sm-2"},[_c('div',{staticClass:"icon-wrapper"},[_c('icon',{staticClass:"icon",attrs:{"name":"shopping-basket"}})],1)]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-sm-2"},[_c('div',{staticClass:"icon-wrapper"},[_c('icon',{staticClass:"icon",attrs:{"name":"industry"}})],1)]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-sm-2"},[_c('div',{staticClass:"icon-wrapper"},[_c('icon',{staticClass:"icon",attrs:{"name":"cubes"}})],1)]),_vm._v(" "),_vm._m(3)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column text col-9 col-sm-10"},[_c('h2',[_vm._v("Supermarket")]),_vm._v(" "),_c('p',[_vm._v("Our supermarkets are built for your convenience and offer easy access to all our goods. Suitable for bulk or every day shopping, our products are competitively priced to cater to all your shopping needs, and our helpful staff provide friendly, caring, and efficient service creating a satisfying shopping experience just for you.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-3 col-sm-2"},[_c('div',{staticClass:"icon-wrapper"},[_c('img',{staticClass:"icon",attrs:{"src":__webpack_require__("xPYu")}})])]),_vm._v(" "),_c('div',{staticClass:"column text col-9 col-sm-10"},[_c('h2',[_vm._v("Butchery")]),_vm._v(" "),_c('p',[_vm._v("All Jwayelani butcheries are supplied by our progressive Meat Plant. We supply meat of the finest grade – all carefully prepared, packaged, and labelled for your convenience. Our extensive range of quality meats provide you with great choice at great prices, and is the basis of our customers loyalty and trust.")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column text col-9 col-sm-10"},[_c('h2',[_vm._v("Meat Plant")]),_vm._v(" "),_c('p',[_vm._v("All Jwayelani butcheries and supermarkets are supplied by this state-of-the-art, professionally run meat plant. Our Meat Plant ensures the highest standards of manufacturing processes, providing a wide range of quality meat products. Our expertly trained staff constantly strive towards a safe and hazard-free food preparation environment so that you get only the best when shopping at Jwayelani.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"column text col-9 col-sm-10"},[_c('h2',[_vm._v("Distribution Centre")]),_vm._v(" "),_c('p',[_vm._v("The Jwayelani Distribution Centre is used for the storage and re-distribution of dry goods. All Jwayelani supermarkets are supplied by this centre, which is dedicated to providing excellent service through the efficient delivery of products, creating a better stocked store that can cater to all your shopping needs.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SiBX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70363402_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("aPu1");
function injectStyle (ssrContext) {
  __webpack_require__("SiBX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-70363402"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70363402_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UYIS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'j-footer',
  data: function data() {
    return {};
  },

  methods: {
    scrollTo: function scrollTo(id, gaLabel) {
      window.gtag('event', 'click', {
        'event_category': 'footer',
        'event_label': gaLabel
      });
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$scrollTo.go(id, null, 60);
      this.sideNavActive = false;
    }
  }
});

/***/ }),

/***/ "X/gF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X4if":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__ = __webpack_require__("PJX0");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b294b71a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__ = __webpack_require__("+r2N");
function injectStyle (ssrContext) {
  __webpack_require__("F4hn")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b294b71a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Landing_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b294b71a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Landing_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "X7Cb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/jwayelani-logo-full.8ace364.png";

/***/ }),

/***/ "XjXy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-about.dc80f6c.jpg";

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YZ92":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"banner half-vh"},[_c('img',{staticClass:"banner-image",attrs:{"src":__webpack_require__("gNjp"),"alt":"","srcset":_vm.photos.xs + ' 320w, ' + _vm.photos.s + ' 768w, ' + _vm.photos.m + ' 1440w, ' + _vm.photos.l + ' 1920w'}})]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"store-locator"}},[_c('div',{staticClass:"text-content-wrapper"},[_c('h1',[_vm._v("Store Locator")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg find-closest",attrs:{"type":"button"},on:{"click":_vm.findClosestStore}},[_vm._v("\n        Find Closest Store "),_c('icon',{staticClass:"chevron-right-icon",attrs:{"name":"chevron-right"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group search-form-group"},[_c('icon',{staticClass:"search-icon",attrs:{"name":"search"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.storeFilter),expression:"storeFilter"}],staticClass:"form-control",attrs:{"type":"text","id":"search","name":"search","placeholder":"Search"},domProps:{"value":(_vm.storeFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.storeFilter=$event.target.value}}})],1),_vm._v(" "),_c('ul',{staticClass:"stores"},_vm._l((_vm.filteredStores),function(marker,index){return _c('li',{on:{"click":function($event){return _vm.showStore(marker)}}},[_vm._v("\n          "+_vm._s(marker.name)+"\n        ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"google-maps-wrapper",class:{ active: _vm.map.active }},[_c('button',{staticClass:"close",attrs:{"type":"button","name":"button"},on:{"click":function($event){_vm.map.active = false;}}},[_c('icon',{staticClass:"times-icon",attrs:{"name":"times"}})],1),_vm._v(" "),_c('gmap-map',{attrs:{"center":_vm.map.center,"zoom":16,"options":_vm.map.options},on:{"click":function($event){return _vm.goToStore(_vm.currentMarker)}}},_vm._l((_vm.map.markers),function(marker,index){return _c('gmap-marker',{key:index,attrs:{"position":marker.coordinates,"clickable":true,"draggable":false},on:{"click":function($event){_vm.map.center=marker.coordinates}}})}),1),_vm._v(" "),(_vm.currentMarker)?_c('div',{staticClass:"info"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-content-wrapper"},[_c('h5',[_vm._v(_vm._s(_vm.currentMarker.name))]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('icon',{staticClass:"map-marker-icon",attrs:{"name":"map-marker"}})],1),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('h6',[_vm._v("Address")]),_vm._v(" "),_c('p',_vm._l((_vm.currentMarker.address.split(',')),function(line,lineNumber){return _c('span',{attrs:{"index":lineNumber}},[_vm._v("\n                  "+_vm._s(line)),(lineNumber < _vm.currentMarker.address.split(',').length-1)?_c('span',{staticClass:"comma"},[_vm._v(",")]):_vm._e(),_c('br')])}),0)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-2"},[_c('icon',{staticClass:"phone-icon",attrs:{"name":"phone"}})],1),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('h6',[_vm._v("Telephone")]),_vm._v(" "),_c('p',[_vm._l((_vm.currentMarker.phone.split(' / ')),function(number,numberIndex){return _c('span',{attrs:{"index":numberIndex}},[_vm._v("\n                  "+_vm._s(number)+" "),(numberIndex < _vm.currentMarker.phone.split(' / ').length-1)?_c('span',{staticClass:"pipe"},[_vm._v("/")]):_vm._e()])}),_c('br'),_vm._v("\n                "+_vm._s(_vm.currentMarker.fax)+" "),(_vm.currentMarker.fax)?_c('span',[_vm._v("(fax)")]):_vm._e()],2)])])])])]):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__("lO7g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_News__ = __webpack_require__("EZvQ");




//import PromotionBannerTerms from '@/components/PromotionBannerTerms'
//import GoldenSmileBannerTerms from '@/components/GoldenSmileBannerTerms'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home__["a" /* default */]
  }, {
    path: '/news',
    name: 'News',
    component: __WEBPACK_IMPORTED_MODULE_3__components_News__["a" /* default */] /*,
                    {
                     path: '/win-a-car-ts-and-cs',
                     name: 'PromotionBannerTerms',
                     component: PromotionBannerTerms
                    },
                    {
                     path: '/golden-smile-ts-and-cs',
                     name: 'GoldenSmileBannerTerms',
                     component: GoldenSmileBannerTerms
                    }*/
  }]
}));

/***/ }),

/***/ "ZPKi":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "aPu1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v("\n      Copyright © "+_vm._s(new Date().getFullYear())+" – Jwayelani\n    ")]),_vm._v(" "),_c('a',{staticClass:"back-to-top",on:{"click":function($event){return _vm.scrollTo('main-nav', 'back to top')}}},[_vm._v("Back to Top "),_c('icon',{staticClass:"icon",attrs:{"name":"chevron-up"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "arl9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-about_xs.01d1d73.jpg";

/***/ }),

/***/ "b2as":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-about_s.a6e694a.jpg";

/***/ }),

/***/ "c0Rt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cICq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dXrS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var icons = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fa-icon',
  props: {
    name: {
      type: String,
      validator: function validator(val) {
        if (val && !(val in icons)) {
          console.warn('Invalid prop: prop "name" is referring to an unregistered icon "' + val + '".' + '\nPlease make sure you have imported this icon before using it.');
          return false;
        }
        return true;
      }
    },
    scale: [Number, String],
    spin: Boolean,
    inverse: Boolean,
    pulse: Boolean,
    flip: {
      validator: function validator(val) {
        return val === 'horizontal' || val === 'vertical';
      }
    },
    label: String
  },
  data: function data() {
    return {
      x: false,
      y: false,
      childrenWidth: 0,
      childrenHeight: 0,
      outerScale: 1
    };
  },

  computed: {
    normalizedScale: function normalizedScale() {
      var scale = this.scale;
      scale = typeof scale === 'undefined' ? 1 : Number(scale);
      if (isNaN(scale) || scale <= 0) {
        console.warn('Invalid prop: prop "scale" should be a number over 0.', this);
        return this.outerScale;
      }
      return scale * this.outerScale;
    },
    klass: function klass() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        'fa-icon': true,
        'fa-spin': this.spin,
        'fa-flip-horizontal': this.flip === 'horizontal',
        'fa-flip-vertical': this.flip === 'vertical',
        'fa-inverse': this.inverse,
        'fa-pulse': this.pulse
      }, this.$options.name, true);
    },
    icon: function icon() {
      if (this.name) {
        return icons[this.name];
      }
      return null;
    },
    box: function box() {
      if (this.icon) {
        return '0 0 ' + this.icon.width + ' ' + this.icon.height;
      }
      return '0 0 ' + this.width + ' ' + this.height;
    },
    ratio: function ratio() {
      if (!this.icon) {
        return 1;
      }
      var _icon = this.icon,
          width = _icon.width,
          height = _icon.height;

      return Math.max(width, height) / 16;
    },
    width: function width() {
      return this.childrenWidth || this.icon && this.icon.width / this.ratio * this.normalizedScale || 0;
    },
    height: function height() {
      return this.childrenHeight || this.icon && this.icon.height / this.ratio * this.normalizedScale || 0;
    },
    style: function style() {
      if (this.normalizedScale === 1) {
        return false;
      }
      return {
        fontSize: this.normalizedScale + 'em'
      };
    },
    raw: function raw() {
      // generate unique id for each icon's SVG element with ID
      if (!this.icon || !this.icon.raw) {
        return null;
      }
      var raw = this.icon.raw;
      var ids = {};
      raw = raw.replace(/\s(?:xml:)?id=(["']?)([^"')\s]+)\1/g, function (match, quote, id) {
        var uniqueId = getId();
        ids[id] = uniqueId;
        return ' id="' + uniqueId + '"';
      });
      raw = raw.replace(/#(?:([^'")\s]+)|xpointer\(id\((['"]?)([^')]+)\2\)\))/g, function (match, rawId, _, pointerId) {
        var id = rawId || pointerId;
        if (!id || !ids[id]) {
          return match;
        }

        return '#' + ids[id];
      });

      return raw;
    }
  },
  mounted: function mounted() {
    var _this = this;

    if (!this.name && this.$children.length === 0) {
      console.warn('Invalid prop: prop "name" is required.');
      return;
    }

    if (this.icon) {
      return;
    }

    var width = 0;
    var height = 0;
    this.$children.forEach(function (child) {
      child.outerScale = _this.normalizedScale;

      width = Math.max(width, child.width);
      height = Math.max(height, child.height);
    });
    this.childrenWidth = width;
    this.childrenHeight = height;
    this.$children.forEach(function (child) {
      child.x = (width - child.width) / 2;
      child.y = (height - child.height) / 2;
    });
  },
  register: function register(data) {
    for (var name in data) {
      var icon = data[name];

      if (!icon.paths) {
        icon.paths = [];
      }
      if (icon.d) {
        icon.paths.push({ d: icon.d });
      }

      if (!icon.polygons) {
        icon.polygons = [];
      }
      if (icon.points) {
        icon.polygons.push({ points: icon.points });
      }

      icons[name] = icon;
    }
  },

  icons: icons
});

var cursor = 0xd4937;
function getId() {
  return 'fa-' + (cursor++).toString(16);
}

/***/ }),

/***/ "e9Us":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contact-us',
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_0_vue_recaptcha__["a" /* default */] },
  computed: {
    isValidForm: function isValidForm() {
      if (!this.form.name) {
        alert("Please enter a Name");
        return false;
      }

      if (!this.form.email) {
        alert("Please enter a valid Email Address");
        return false;
      }

      if (!this.form.message) {
        alert("Please enter a Message");
        return false;
      }

      if (!this.recaptchaKey) {
        alert("Please complete the reCAPTCHA");
        return false;
      }

      return true;
    }
  },
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        isSending: false,
        isSent: false
      },
      recaptcha: null,
      recaptchaKey: null,
      recaptchaSiteKey: '6LdvJsQeAAAAAONApzSwH0ZGDtIpcqLsWoa4VWG_'
    };
  },

  methods: {
    onVerify: function onVerify(response) {
      this.recaptchaKey = response;
    },
    onExpired: function onExpired() {
      this.recaptchaKey = null;
      this.$refs.recaptcha.reset();
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (!this.isValidForm) {
        return;
      }

      window.gtag('event', 'click', {
        'event_category': 'contact us',
        'event_label': 'submit'
      });

      this.form.isSending = true;
      this.$http.post('https://comms13th.azurewebsites.net/api/jwayelani', {
        fullName: this.form.name,
        emailAddress: this.form.email,
        message: this.form.message,
        recaptcha: this.recaptchaKey
      }).then(function (response) {
        // this.$ga.event({eventCategory: 'contact us', eventAction: 'server response', eventLabel: 'sent'})
        this.form.isSent = true;
        this.form.isSending = false;

        this.form.name = '';
        this.form.email = '';
        this.form.message = '';

        this.$refs.recaptcha.reset();
        this.errors.clear();

        setTimeout(function () {
          this.form.isSent = false;
        }.bind(this), 3000);
      }, function (error) {
        // this.$ga.exception(error)
        this.form.isSending = false;
      }).then(function () {
        this.errors.clear();
      });
    }
  }
});

/***/ }),

/***/ "eWwk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__ = __webpack_require__("lfBI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e5d9f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__ = __webpack_require__("lL+q");
function injectStyle (ssrContext) {
  __webpack_require__("cICq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01e5d9f0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Promotions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01e5d9f0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Promotions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "gNjp":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-store-locator.a2c9524.jpg";

/***/ }),

/***/ "gkTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));

/***/ }),

/***/ "hQ4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));

/***/ }),

/***/ "iyad":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"main-nav"}},[_c('div',{staticClass:"nav-wrapper"},[_c('div',{staticClass:"header-bar"},[_c('div',{staticClass:"logo",on:{"click":function($event){return _vm.scrollTo('main-nav')}}},[_c('img',{attrs:{"src":__webpack_require__("ZPKi"),"alt":""}})]),_vm._v(" "),_c('button',{staticClass:"toggle-side-nav",class:{ active: _vm.sideNavActive },on:{"click":function($event){_vm.sideNavActive = !_vm.sideNavActive}}},[_c('span',{staticClass:"line line-top"}),_vm._v(" "),_c('span',{staticClass:"line line-middle"}),_vm._v(" "),_c('span',{staticClass:"line line-bottom"})])]),_vm._v(" "),_c('ul',{staticClass:"off-canvas",class:{ active: _vm.sideNavActive }},[_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('home')}}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('about-us')}}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('promotions')}}},[_vm._v("Promotions")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('store-locator')}}},[_vm._v("Store Locator")])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/news"}},[_vm._v("News")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('contact-us')}}},[_vm._v("Contact Us")])])])]),_vm._v(" "),_c('div',{staticClass:"banner"},[_c('div',{staticClass:"banner-image"}),_vm._v(" "),_c('img',{staticClass:"banner-logo",attrs:{"src":__webpack_require__("X7Cb"),"alt":""}}),_vm._v(" "),_c('div',{directives:[{name:"sticky",rawName:"v-sticky"}],staticClass:"banner-nav"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"logo",on:{"click":function($event){return _vm.scrollTo('main-nav', 'landing')}}},[_c('img',{attrs:{"src":__webpack_require__("ZPKi"),"alt":""}})]),_vm._v(" "),_c('ul',[_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('home', 'home')}}},[_vm._v("Home")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('about-us', 'about us')}}},[_vm._v("About Us")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('promotions', 'promotions')}}},[_vm._v("Promotions")])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('store-locator', 'store locator')}}},[_vm._v("Store Locator")])]),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":"/news"}},[_vm._v("News")])],1),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.scrollTo('contact-us', 'contact us')}}},[_vm._v("Contact Us")])])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kHun":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__ = __webpack_require__("4ajz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8aa16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__ = __webpack_require__("Qso1");
function injectStyle (ssrContext) {
  __webpack_require__("0sSV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3a8aa16c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AboutUs_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a8aa16c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AboutUs_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lL+q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"promotions"},[_c('div',{staticClass:"banner half-vh"},[_c('img',{staticClass:"banner-image",attrs:{"src":__webpack_require__("gNjp"),"alt":"","srcset":_vm.photos.xs + ' 320w, ' + _vm.photos.s + ' 768w, ' + _vm.photos.m + ' 1440w, ' + _vm.photos.l + ' 1920w'}})]),_vm._v(" "),_c('div',{staticClass:"container",attrs:{"id":"promotions"}},[_c('div',{staticClass:"text-content-wrapper"},[_c('h1',[_vm._v("Promotions")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-lg find-closest",attrs:{"type":"button"},on:{"click":_vm.findClosestStore}},[_vm._v("\n        Find Closest Store "),_c('icon',{staticClass:"chevron-right-icon",attrs:{"name":"chevron-right"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group search-form-group"},[_c('icon',{staticClass:"search-icon",attrs:{"name":"search"}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.storeFilter),expression:"storeFilter"}],staticClass:"form-control",attrs:{"type":"text","id":"search","name":"search","placeholder":"Search"},domProps:{"value":(_vm.storeFilter)},on:{"input":function($event){if($event.target.composing){ return; }_vm.storeFilter=$event.target.value}}})],1),_vm._v(" "),_c('ul',{staticClass:"stores"},_vm._l((_vm.filteredStores),function(store,index){return _c('li',{on:{"click":function($event){return _vm.onStoreChange(store)}}},[_vm._v("\n          "+_vm._s(store.name)+"\n        ")])}),0)])]),_vm._v(" "),_c('div',{staticClass:"banner-wrapper",class:{ active: _vm.banner.active }},[_c('button',{staticClass:"close",attrs:{"type":"button","name":"button"},on:{"click":function($event){_vm.banner.active = false;}}},[_c('icon',{staticClass:"times-icon",attrs:{"name":"times"}})],1),_vm._v(" "),_c('div',{directives:[{name:"leaflet",rawName:"v-leaflet"},{name:"show",rawName:"v-show",value:(_vm.promotionItems.length),expression:"promotionItems.length"}],staticClass:"leaflet"},[_c('ul',{staticClass:"pages"},[_vm._l((_vm.promotionItems),function(promotionItem){return _c('li',{staticClass:"page"},[_c('img',{attrs:{"src":promotionItem.coverImageUrl,"alt":""}}),_vm._v(" "),_c('a',{staticStyle:{"color":"#d51d2f","z-index":"999","position":"absolute","bottom":"0","left":"0","width":"100%","text-align":"center","font-weight":"bold","height":"30px"},attrs:{"href":promotionItem.documentUrl,"target":"_blank"}},[_vm._v("View Promotion")])])}),_vm._v(" "),_c('li',{staticClass:"clearfix"})],2),_vm._v(" "),_c('div',{staticClass:"next-page"},[_c('icon',{staticClass:"icon",attrs:{"name":"chevron-right"}})],1),_vm._v(" "),_c('div',{staticClass:"prev-page"},[_c('icon',{staticClass:"icon",attrs:{"name":"chevron-left"}})],1)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.currentStore),expression:"!currentStore"}],staticStyle:{"height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('h4',[_vm._v("Please select your nearest store to view our latest specials.")])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentStore && _vm.promotionItems.length === 0),expression:"currentStore && promotionItems.length === 0"}],staticStyle:{"height":"100%","display":"flex","align-items":"center","justify-content":"center"}},[_c('h4',[_vm._v("There are currently no promotions for your selected store.")])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lO7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__("Fs8J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b2f73c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__("Ngrk");
function injectStyle (ssrContext) {
  __webpack_require__("0R+G")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-10b2f73c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b2f73c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lfBI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful__ = __webpack_require__("c/SZ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful__["a" /* createClient */])({
  space: "r4kjztul5agf",
  accessToken: "woQwhNRxg--st0klHyPAvNk5tQF6q0HpjB1TqSk2EtE"
});

var _photos = {
  xs: __webpack_require__("1xb8"),
  s: __webpack_require__("rLas"),
  m: __webpack_require__("AxXu"),
  l: __webpack_require__("gNjp")
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'promotions',
  created: function created() {
    client.getEntries({
      content_type: "store"
    }).then(function (response) {
      this.$data.stores = response.items.map(function (store) {
        var id = store.sys.id;
        var displayName = store.fields.displayName;


        return {
          id: id,
          name: displayName
        };
      });
    }.bind(this));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      }.bind(this));
    }
  },
  data: function data() {
    return {
      stores: [],
      currentStore: null,
      storeFilter: '',
      promotionItems: [],
      banner: {
        active: false
      }
    };
  },

  methods: {
    findClosestStore: function findClosestStore() {
      if (!this.currentLocation) {
        return;
      }

      client.getEntries({
        content_type: "store",
        "fields.location[near]": this.currentLocation.lat + "," + this.currentLocation.lng,
        "limit": 1
      }).then(function (response) {
        if (response.items.length > 0) {
          var nearestStore = response.items[0];
          var id = nearestStore.sys.id;
          var displayName = nearestStore.fields.displayName;


          this.$data.storeFilter = displayName;

          var store = this.$data.stores.filter(function (item) {
            return item.id === id;
          });

          if (store.length > 0) {
            this.onStoreChange(store[0]);
          }
        }
      }.bind(this));
    },
    onPromotionClick: function onPromotionClick(promotionItem) {
      window.open(promotionItem.documentUrl, '_blank');
    },
    onStoreChange: function onStoreChange(store) {
      this.$data.currentStore = store;

      client.getEntries({
        content_type: "promotion",
        include: 2,
        "fields.stores.sys.id": store.id
      }).then(function (response) {

        var parsedPromotionItems = [];
        response.items.forEach(function (promotion) {
          var promotionItems = promotion.fields.promotionItems;


          promotionItems.forEach(function (promotionItem) {
            var _promotionItem$fields = promotionItem.fields,
                name = _promotionItem$fields.name,
                coverImage = _promotionItem$fields.coverImage,
                document = _promotionItem$fields.document;

            var coverImageUrl = coverImage.fields.file.url;
            var documentUrl = document.fields.file.url;

            parsedPromotionItems.push({
              name: name,
              coverImageUrl: coverImageUrl,
              documentUrl: documentUrl
            });
          });
        });

        this.$data.promotionItems = parsedPromotionItems;
      }.bind(this));

      this.$data.banner.active = true;
    }
  },
  computed: {
    photos: function photos() {
      return _photos;
    },

    filteredStores: function filteredStores() {
      var storeFilter = this.$data.storeFilter.toLowerCase();

      var ordered = _.orderBy(this.$data.stores, ['name'], ['asc']);

      if (!storeFilter || storeFilter === '') {
        return ordered;
      }

      var filtered = _.filter(ordered, function (store) {
        // return true
        var name = store.name.toLowerCase();
        return name.toLowerCase().indexOf(storeFilter) >= 0;
      });
      return filtered;
    }
  },
  directives: {
    leaflet: {
      // directive definition
      inserted: function inserted(el) {
        var dragging = false;

        var containerWidth = el.offsetWidth;

        var pages = el.getElementsByClassName('pages')[0];
        var pagesWidth = pages.offsetWidth;
        var pageWidth = 0;
        // setPagesWidth()

        var scrollSize = pagesWidth - containerWidth;

        var next = el.getElementsByClassName('next-page')[0];
        var prev = el.getElementsByClassName('prev-page')[0];

        var mouseX = 0;
        var prevMouseX = 0;
        var deltaMouseX = 0;
        var pageLeft = 0;

        el.addEventListener('mousedown', scrollStart);
        el.addEventListener('touchstart', scrollStart);
        document.addEventListener('mouseup', scrollEnd);
        document.addEventListener('touchend', scrollEnd);
        el.addEventListener('mousemove', scrollMove);
        el.addEventListener('touchmove', scrollMove);

        next.addEventListener('click', nextTriggered);
        next.addEventListener('touchstart', nextTriggered);

        prev.addEventListener('click', prevTriggered);
        prev.addEventListener('touchstart', prevTriggered);

        window.addEventListener('resize', function () {
          setPagePosition(0);
          scrollSize = pagesWidth - containerWidth;
        });

        function nextTriggered(e) {
          pages.classList.add('animate');
          var newPagePos = 0;

          var safety = 0;
          while (newPagePos >= pageLeft && safety < 20) {
            safety++;
            newPagePos -= pageWidth;
          }

          setPagePosition(newPagePos);
        }

        function prevTriggered(e) {
          pages.classList.add('animate');
          var newPagePos = -scrollSize;

          var safety = 0;
          while (newPagePos <= pageLeft && safety < 20) {
            safety++;
            newPagePos += pageWidth;
          }

          setPagePosition(newPagePos);
        }

        function scrollStart(e) {
          //e.preventDefault()
          pages.classList.remove('animate');

          mouseX = getRelativeMouseX(event);
          prevMouseX = mouseX;
          dragging = true;
        }

        function scrollEnd(e) {
          //e.preventDefault()
          dragging = false;
        }

        function scrollMove(e) {
          if (dragging) {
            mouseX = getRelativeMouseX(event);
            deltaMouseX = prevMouseX - mouseX;
            prevMouseX = mouseX;
            setPagePosition(pageLeft - deltaMouseX);
          }
        }

        function getRelativeMouseX(event) {
          var x = 0;

          if (event.changedTouches) {
            x = event.changedTouches[0].pageX;
          } else {
            x = event.pageX;
          }

          return x - el.offsetLeft;
        }

        function setPagesWidth() {
          scrollSize = pagesWidth - containerWidth;
          var pageElements = pages.getElementsByClassName('page');

          if (!(pageElements && pageElements.length > 0)) {
            return;
          }

          pageWidth = pageElements[0].offsetWidth;

          var newPagesWidth = 0;
          for (var i = 0; i < pageElements.length; i++) {
            newPagesWidth += pageElements[i].offsetWidth;
          }
          pagesWidth = newPagesWidth + 1;

          // if (pages.style.width !== pagesWidth + 'px') {
          pages.style.width = pagesWidth + 'px';
          // }
        }

        function setPagePosition(pagePosition) {
          setPagesWidth();

          if (prev.classList && next.classList) {
            prev.classList.remove('hide');
            next.classList.remove('hide');
          }

          if (pagePosition > 0) {
            pagePosition = 0;
          }

          if (pagePosition < -scrollSize) {
            pagePosition = -scrollSize;
          }

          pageLeft = pagePosition;

          if (next.classList && pageLeft < -scrollSize + 10) {
            next.classList.add('hide');
          }

          if (prev.classList && pageLeft > -10) {
            prev.classList.add('hide');
          }

          pages.style.transform = 'translateX(' + pageLeft + 'px)';
        }
      }
    }
  }
});

/***/ }),

/***/ "mvlf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__ = __webpack_require__("olAn");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'news',
  created: function created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.gtag('event', 'page', {
      'page': '/news',
      'title': 'News'
    });
  },
  components: { VueRecaptcha: __WEBPACK_IMPORTED_MODULE_1_vue_recaptcha__["a" /* default */], JFooter: __WEBPACK_IMPORTED_MODULE_0__components_Footer__["a" /* default */] },
  computed: {
    isValidForm: function isValidForm() {
      if (!this.form.name) {
        alert("Please enter a Name");
        return false;
      }

      if (!this.form.email) {
        alert("Please enter a valid Email Address");
        return false;
      }

      if (!this.form.message) {
        alert("Please enter a Message");
        return false;
      }

      if (!this.recaptchaKey) {
        alert("Please complete the reCAPTCHA");
        return false;
      }

      return true;
    }
  },
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
        isSending: false,
        isSent: false
      },
      recaptcha: null,
      recaptchaKey: null,
      recaptchaSiteKey: '6LdvJsQeAAAAAONApzSwH0ZGDtIpcqLsWoa4VWG_'
    };
  },

  methods: {
    onVerify: function onVerify(response) {
      this.recaptchaKey = response;
    },
    onExpired: function onExpired() {
      this.recaptchaKey = null;
      this.$refs.recaptcha.reset();
    },
    onSubmit: function onSubmit(e) {
      e.preventDefault();

      if (!this.isValidForm) {
        return;
      }

      window.gtag('event', 'click', {
        'event_category': 'notification intent',
        'event_label': 'submit'
      });

      this.form.isSending = true;
      this.$http.post('https://comms13th.azurewebsites.net/api/jwayelaniintent', {
        fullName: this.form.name,
        emailAddress: this.form.email,
        message: this.form.message,
        recaptcha: this.recaptchaKey
      }).then(function (response) {
        // this.$ga.event({eventCategory: 'contact us', eventAction: 'server response', eventLabel: 'sent'})
        this.form.isSent = true;
        this.form.isSending = false;

        this.form.name = '';
        this.form.email = '';
        this.form.message = '';

        this.$refs.recaptcha.reset();
        this.errors.clear();

        setTimeout(function () {
          this.form.isSent = false;
        }.bind(this), 3000);
      }, function (error) {
        // this.$ga.exception(error)
        this.form.isSending = false;
      }).then(function () {
        this.errors.clear();
      });
    }
  }
});

/***/ }),

/***/ "oJPq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ScrollTo = {};

ScrollTo.install = function (Vue) {
  var service = {};

  var scrollInfo = {
    startOffset: 0,
    targetOffset: 0,
    currentOffset: 0
  };

  var elapsedTime = 0;
  var startTime = 0;
  var isUpdating = false;
  var scrollSpeed = 500;
  var scrollOffset = 0;
  var scrollElement = null;

  service.isScrolling = false;

  service.go = function (elementId, speed, offset) {
    cancelUpdate();

    scrollElement = document.getElementById(elementId);
    if (!scrollElement) {
      return;
    }

    if (speed) {
      scrollSpeed = speed;
    }
    if (offset) {
      scrollOffset = offset;
    }

    var coords = Vue.$utils.getCoords(scrollElement);

    if (!coords) {
      return;
    }

    scrollInfo.currentOffset = coords.scrollTop;
    scrollInfo.startOffset = coords.scrollTop;
    scrollInfo.targetOffset = coords.top - scrollOffset;

    initUpdate();
  };

  function update() {
    if (!scrollElement) {
      return;
    }

    elapsedTime = Date.now() - startTime;

    if (elapsedTime < scrollSpeed) {
      scrollInfo.currentOffset = Math.round(Vue.$utils.lerp(scrollInfo.startOffset, scrollInfo.targetOffset, Vue.$easing.easeInOutQuad(elapsedTime / scrollSpeed)));
    } else {
      scrollInfo.currentOffset = scrollInfo.targetOffset;
      cancelUpdate();
    }

    window.scrollTo(0, scrollInfo.currentOffset);

    if (isUpdating) {
      requestAnimationFrame(update);
    }
  }

  function initUpdate() {
    service.isScrolling = isUpdating = true;
    startTime = Date.now();
    update();
  }

  function cancelUpdate() {
    service.isScrolling = isUpdating = false;
    startTime = 0;
    elapsedTime = 0;
  }

  Vue.$scrollTo = service;
};

/* harmony default export */ __webpack_exports__["a"] = (ScrollTo);

/***/ }),

/***/ "pLgy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('lazy-load', {
  inserted: function inserted(el, binding) {
    var loader = document.createElement('div');
    loader.classList.add('loader');

    el.parentNode.appendChild(loader);
    el.classList.add('loading');
    el.setAttribute('src', binding.value);
    el.onload = function () {
      setTimeout(function () {
        loader.classList.add('hide');
        el.classList.remove('loading');
      }, 200);
    };
  }
});

/***/ }),

/***/ "ppOi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    this.hello();
  },
  methods: {
    hello: function hello() {},
    getDistanceFromCoordinates: function getDistanceFromCoordinates(from, to) {
      var R = 6371;
      var dLat = this.toDeg(to.lat - from.lat);
      var dLon = this.toDeg(to.lng - from.lng);
      var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(this.toDeg(from.lat)) * Math.cos(this.toDeg(to.lat)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      var d = R * c;
      return d;
    },
    toDeg: function toDeg(deg) {
      return deg * (Math.PI / 180);
    }
  }
});

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__("hQ4h");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("5ANv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5e569f3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qoDK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r0IB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Utils = {};

Utils.install = function (Vue) {
  var service = {
    // Get a value between two values
    clamp: function clamp(value, min, max) {
      if (value < min) {
        return min;
      } else if (value > max) {
        return max;
      }

      return value;
    },
    // Get the linear interpolation between two value
    lerp: function lerp(value1, value2, amount) {
      amount = amount < 0 ? 0 : amount;
      amount = amount > 1 ? 1 : amount;
      return value1 + (value2 - value1) * amount;
    },
    getCoords: function getCoords(elem) {
      // crossbrowser version
      if (!elem) {
        return null;
      }

      var box = elem.getBoundingClientRect();

      var body = document.body;
      var docEl = document.documentElement;

      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

      var clientTop = docEl.clientTop || body.clientTop || 0;
      var clientLeft = docEl.clientLeft || body.clientLeft || 0;

      var top = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;

      return {
        top: Math.round(top),
        left: Math.round(left),
        scrollTop: scrollTop,
        clientTop: clientTop
      };
    }

  };

  Vue.$utils = service;
};

/* harmony default export */ __webpack_exports__["a"] = (Utils);

/***/ }),

/***/ "rLas":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photo-store-locator_s.46e0ff1.jpg";

/***/ }),

/***/ "sl25":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__ = __webpack_require__("HKjq");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367183bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__ = __webpack_require__("NzJi");
function injectStyle (ssrContext) {
  __webpack_require__("GYib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-367183bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Gallery_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_367183bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gallery_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "t/Fq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'main-nav',
  data: function data() {
    return {
      sideNavActive: false
    };
  },

  methods: {
    scrollTo: function scrollTo(id, gaLabel) {
      window.gtag('event', 'click', {
        'event_category': 'main navigation',
        'event_label': gaLabel
      });
      __WEBPACK_IMPORTED_MODULE_0_vue__["default"].$scrollTo.go(id, null, 60);
      this.sideNavActive = false;
    }
  }
});

/***/ }),

/***/ "tngd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "u5Yc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vGh4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "xPYu":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyMDkuMjkgMjAwLjg4Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDI8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJhcnR3b3JrIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xOTguMiw0NC40N0MxODAuMjMsMTYuMjEsMTU0LjU0LDAsMTI3LjcxLDBWNGgwVjBDMTExLjg0LDAsOTYuNTMsNS43OSw4My40MywxNi43NSw2OS42OCwyOC4yNSw1OC44LDQ0LjgyLDUxLjEsNjYsNDYuODYsNzcuNjUsMzcuMjMsODguODQsMjcuOTMsOTkuNjdzLTE4LjksMjItMjQsMzQuNDRjLTYuMjIsMTUuMDctNSwyOS41OCwzLjc2LDQ0LjM0czI1LjI5LDIyLjQ0LDQ4LDIyLjQ0YzIzLjg0LDAsNTMuMS04Ljc0LDgwLjI5LTI0LDI4LjY4LTE2LjA3LDUxLjEzLTM3LDYzLjIxLTU5QzIxMyw5Mi42MiwyMTIuNjcsNjcuMjMsMTk4LjIsNDQuNDdaTTU1LjYxLDE5Mi44OGMtMTguMzgsMC0zMy40My01LjYxLTQxLjA4LTE4LjUyLTI1LjM3LTQyLjc5LDMwLjYzLTY4LjY0LDQ0LjA4LTEwNS42NEM3My42MywyNy40NSwxMDAuNDIsOCwxMjcuNzEsOGMyMy4yMSwwLDQ2Ljc4LDE0LjA3LDYzLjc1LDQwLjc2QzIzNS4xMSwxMTcuNDMsMTIzLDE5Mi44OCw1NS42MSwxOTIuODhaIi8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTI1LDY1LjI1YTEyLDEyLDAsMSwwLDEyLDEyQTEyLDEyLDAsMCwwLDEyNSw2NS4yNVoiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xODYuMzksNTJDMTcxLDI3Ljg0LDE0OS42NiwxNCwxMjcuNzEsMTRoMGMtMTIuNTQsMC0yNC43NSw0LjY3LTM1LjMsMTMuNDlDODAuNTcsMzcuMzgsNzEuMSw1Miw2NC4yNSw3MC43OCw1OS4xNCw4NC44NCw0OC42Nyw5NywzOC41NCwxMDguOGMtOSwxMC40My0xNy40MywyMC4yOC0yMS43MSwzMC42NS00LjQ5LDEwLjg3LTMuNTgsMjEsMi44NywzMS44Niw3LjYzLDEyLjg3LDIzLjc1LDE1LjU4LDM1LjkyLDE1LjU4LDIxLjUyLDAsNDguMjktOC4wOCw3My40NC0yMi4xOCwyNi40Mi0xNC44MSw0Ni45NC0zMy44Miw1Ny43OC01My41NUMxOTguMjcsOTAuMzQsMTk4LjEyLDcwLjQzLDE4Ni4zOSw1MlpNMTI1LDk2LjI1YTE5LDE5LDAsMSwxLDE5LTE5QTE5LDE5LDAsMCwxLDEyNSw5Ni4yNVoiLz48L2c+PC9nPjwvc3ZnPg=="

/***/ }),

/***/ "yUv6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zF5S":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_contentful__ = __webpack_require__("c/SZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_Utils__ = __webpack_require__("ppOi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash__ = __webpack_require__("M4fF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var client = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_contentful__["a" /* createClient */])({
  space: "r4kjztul5agf",
  accessToken: "woQwhNRxg--st0klHyPAvNk5tQF6q0HpjB1TqSk2EtE"
});





var _photos = {
  xs: __webpack_require__("1xb8"),
  s: __webpack_require__("rLas"),
  m: __webpack_require__("AxXu"),
  l: __webpack_require__("gNjp")
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'store-locator',
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_Utils__["a" /* default */]],
  created: function created() {
    client.getEntries({
      content_type: "store"
    }).then(function (response) {
      this.$data.map.markers = response.items.filter(function (store) {
        return !!store.fields.location;
      }).map(function (store) {
        var id = store.sys.id;
        var _store$fields = store.fields,
            displayName = _store$fields.displayName,
            address = _store$fields.address,
            phone = _store$fields.phone,
            location = _store$fields.location;


        return {
          id: id,
          name: displayName,
          address: address,
          phone: phone,
          coordinates: { lat: location.lat, lng: location.lon }
        };
      });

      var lastIndex = this.map.markers.length - 1;
      this.$data.currentMarker = this.map.markers[lastIndex];
      this.$data.map.center = this.map.markers[lastIndex].coordinates;
    }.bind(this));

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (position) {
        this.currentLocation = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
      }.bind(this));
    }
  },
  computed: {
    photos: function photos() {
      return _photos;
    },

    mapCenter: function mapCenter() {
      return this.$data.map.center;
    },
    filteredStores: function filteredStores() {
      if (!this.$data) {
        return this.$data.map.markers;
      }

      var storeFilter = this.$data.storeFilter.toLowerCase();

      var ordered = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.orderBy(this.$data.map.markers, ['name'], ['asc']);

      if (!storeFilter || storeFilter === '') {
        return ordered;
      }

      var filtered = __WEBPACK_IMPORTED_MODULE_3_lodash___default.a.filter(ordered, function (marker) {
        // return true
        var name = marker.name.toLowerCase();
        var address = marker.address.toLowerCase();
        return name.toLowerCase().indexOf(storeFilter) >= 0 || address.indexOf(storeFilter) >= 0;
      });
      return filtered;
    }
  },
  watch: {
    // whenever question changes, this function will run
    mapCenter: function mapCenter(newCenter) {}
  },
  methods: {
    findClosestStore: function findClosestStore() {
      if (!this.currentLocation) {
        return;
      }

      client.getEntries({
        content_type: "store",
        "fields.location[near]": this.currentLocation.lat + "," + this.currentLocation.lng,
        "limit": 1
      }).then(function (response) {
        if (response.items.length > 0) {
          var nearestStore = response.items[0];
          var id = nearestStore.sys.id;

          var store = this.$data.map.markers.filter(function (item) {
            return item.id === id;
          });

          if (store.length > 0) {
            this.showStore(store[0]);
          }
        }
      }.bind(this));
    },
    showStore: function showStore(marker) {
      window.gtag('event', 'click', {
        'event_category': 'store locator',
        'event_label': 'store'
      });
      this.$data.currentMarker = marker;
      this.$data.map.center = marker.coordinates;
      this.$data.map.active = true;
    },
    goToStore: function goToStore(marker) {
      if (!marker) {
        return;
      }

      window.open('http://maps.google.com/?q=' + marker.coordinates.lat + ',' + marker.coordinates.lng, '_blank');
    }
  },
  data: function data() {
    return {
      currentMarker: null,
      storeFilter: '',
      map: {
        active: false,
        options: {
          streetViewControl: false,
          mapTypeControl: false,
          draggable: false,
          zoomControl: false,
          scrollwheel: false,
          fullscreenControl: false,
          disableDoubleClickZoom: true
        },
        center: { lat: -29.83580, lng: 30.910775 },
        markers: []
      }
    };
  }
});

/***/ }),

/***/ "zfG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.b2560c95b97a4fdbcbfd.js